// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/layout/components/AppMain.vue"],"names":[],"mappings":"AAGE;EACE,mBAAA;AAFJ","file":"AppMain.vue","sourcesContent":["\n// fix css style bug in open el-dialog\n.el-popup-parent--hidden {\n  .fixed-header {\n    padding-right: 15px;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
